import React, { useEffect, useRef, useState } from 'react'
import './Layout4C.css';


const Layout4C = ({ data }) => {

    const { canvas, video, brand, title, subTitle, saleDate } = data;

    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    const videoRef = useRef(null);
    const [mode, setMode] = useState("intro");

    useEffect(() => {

        const timer = setTimeout(() => {

            const videoEl = videoRef.current;
            if (!videoEl) return;

            const first = videoEl.getBoundingClientRect();

            setMode("normal");

            requestAnimationFrame(() => {

                const last = videoEl.getBoundingClientRect();

                const scaleX = first.width / last.width;
                const scaleY = first.height / last.height;

                const translateX = first.left - last.left;
                const translateY = first.bottom - last.bottom;

                videoEl.animate(
                    [
                        {
                            transformOrigin: "bottom left",
                            transform: `translate(${translateX}px, ${translateY}px) scale(${scaleX}, ${scaleY})`
                        },
                        {
                            transformOrigin: "bottom left",
                            transform: "translate(0px,0px) scale(1,1)"
                        }
                    ],
                    {
                        duration: 1200,
                        // easing: "cubic-bezier(0.22,1,0.36,1)",
                        easing: "cubic-bezier(0.16, 1, 0.3, 1)", // smoother easing
                        fill: "both"
                    }
                );
            });
        }, 4000);

        return () => clearTimeout(timer);
    }, []);


    useEffect(() => {

        const updateCountdown = () => {

            if (!saleDate) return;

            const targetDate = new Date(`${saleDate}T00:00:00`).getTime();
            const now = new Date().getTime();

            const distance = targetDate - now;

            if (distance <= 0) {
                setTimeLeft({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                });
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((distance / (1000 * 60)) % 60);
            const seconds = Math.floor((distance / 1000) % 60);

            setTimeLeft({
                days,
                hours,
                minutes,
                seconds
            });
        };

        updateCountdown();

        const interval = setInterval(updateCountdown, 1000);

        return () => clearInterval(interval);

    }, [saleDate]);


    const getCanvasBackground = (canvas) => {
        const type = canvas?.backgroundType || 'solid';
        if (type === 'gradient') {
            const angle = Number.isFinite(Number(canvas?.gradientAngle)) ? Number(canvas.gradientAngle) : 135;
            const c1 = canvas?.gradientColor1 || canvas?.backgroundColor || '#e0e0e0';
            const c2 = canvas?.gradientColor2 || '#ffffff';
            return `linear-gradient(${angle}deg, ${c1}, ${c2})`;
        }
        return canvas?.backgroundColor || '#e0e0e0';
    };

    const getDaySuffix = (day) => {
        if (day > 3 && day < 21) return "th";
        switch (day % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        }
    };

    const formatSaleDate = (date) => {

        if (!date) return null;

        const d = new Date(date);
        const day = d.getDate();
        const month = d.toLocaleString("en-US", { month: "short" }).toUpperCase();

        return {
            day,
            suffix: getDaySuffix(day),
            month
        };
    };

    const formattedDate = formatSaleDate(saleDate);

    return (
        <div className={`layout4C-container ${mode}`}>

            <div className="layout4C-top">

                {mode !== "intro" && (
                    <div className="layout4C-left flex flex-col justify-between">

                        <div className="layout4C-brand">
                            {brand?.logoUrl && (
                                <img src={brand.logoUrl} alt="logo" className="layout4C-logo" />
                            )}
                        </div>

                        <h1 className={`layout4C-title`} style={{ color: canvas?.titleTextColor }} >
                            {title}
                        </h1>

                        {/* <div className='h-[1px] w-full bg-white'></div> */}
                        <div className="sparkle-line">
                            <svg className="sparkle-icon" viewBox="0 0 64 64">
                                <path d="M0 0 C0.66 0 1.32 0 2 0 C2.09796875 1.30195312 2.1959375 2.60390625 2.296875 3.9453125 C2.44701769 5.67195341 2.59810956 7.39851196 2.75 9.125 C2.811875 9.9809375 2.87375 10.836875 2.9375 11.71875 C3.43812874 17.14222803 4.31619236 20.74639477 8 25 C10.85007946 26.7196682 13.25094792 27.32103561 16.546875 27.6328125 C17.39121094 27.71660156 18.23554687 27.80039062 19.10546875 27.88671875 C20.41451172 28.00466797 20.41451172 28.00466797 21.75 28.125 C22.63816406 28.21136719 23.52632812 28.29773438 24.44140625 28.38671875 C26.62702936 28.59823066 28.81308238 28.80240227 31 29 C31 29.66 31 30.32 31 31 C29.69804688 31.09796875 28.39609375 31.1959375 27.0546875 31.296875 C25.32804659 31.44701769 23.60148804 31.59810956 21.875 31.75 C21.0190625 31.811875 20.163125 31.87375 19.28125 31.9375 C13.85777197 32.43812874 10.25360523 33.31619236 6 37 C4.2803318 39.85007946 3.67896439 42.25094792 3.3671875 45.546875 C3.28339844 46.39121094 3.19960938 47.23554687 3.11328125 48.10546875 C3.03464844 48.97816406 2.95601562 49.85085937 2.875 50.75 C2.78863281 51.63816406 2.70226562 52.52632812 2.61328125 53.44140625 C2.40176934 55.62702936 2.19759773 57.81308238 2 60 C1.34 60 0.68 60 0 60 C-0.09796875 58.69804688 -0.1959375 57.39609375 -0.296875 56.0546875 C-0.44701769 54.32804659 -0.59810956 52.60148804 -0.75 50.875 C-0.811875 50.0190625 -0.87375 49.163125 -0.9375 48.28125 C-1.43812874 42.85777197 -2.31619236 39.25360523 -6 35 C-8.85007946 33.2803318 -11.25094792 32.67896439 -14.546875 32.3671875 C-15.39121094 32.28339844 -16.23554688 32.19960938 -17.10546875 32.11328125 C-17.97816406 32.03464844 -18.85085937 31.95601562 -19.75 31.875 C-20.63816406 31.78863281 -21.52632812 31.70226562 -22.44140625 31.61328125 C-24.62702936 31.40176934 -26.81308238 31.19759773 -29 31 C-29 30.34 -29 29.68 -29 29 C-27.69804687 28.90203125 -26.39609375 28.8040625 -25.0546875 28.703125 C-23.32804659 28.55298231 -21.60148804 28.40189044 -19.875 28.25 C-19.0190625 28.188125 -18.163125 28.12625 -17.28125 28.0625 C-11.87061737 27.56305699 -8.21685787 26.71532235 -4 23 C-0.18312663 16.29267883 -0.34151581 7.51334788 0 0 Z"
                                    fill="white"
                                    transform="translate(31,2)" />
                            </svg>
                        </div>

                    </div>
                )}

                <div className="layout4C-right">
                    <div ref={videoRef} className="layout4C-video-section">
                        {video?.url ? (
                            <video
                                src={video.url}
                                autoPlay
                                muted
                                loop
                                playsInline
                                className="layout4C-video"
                            />
                        ) : (
                            <div className="layout4C-video-placeholder">
                                <div className="layout4C-play">▶</div>
                                <div>Upload Video</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>


            {mode !== "intro" && (
                <div className="layout4C-bottom">

                    <div className="layout4C-bottom-title" style={{ color: canvas?.subTitleTextColor }}>
                        {formattedDate && (
                            <>
                                STARTS {formattedDate.day}
                                <sup>{formattedDate.suffix}</sup> {formattedDate.month}
                            </>
                        )}
                    </div>

                    <div className="counter-box" style={{ background: getCanvasBackground(canvas) }}>

                        <div className="counter-item">
                            <span className="counter-number">{String(timeLeft.days).padStart(2, "0")}</span>
                            <span className="counter-label">DAYS</span>
                        </div>

                        <div className="counter-divider">
                            <svg className="divider-sparkle" viewBox="0 0 64 64">
                                <path d="M0 0 C0.66 0 1.32 0 2 0 C2.09796875 1.30195312 2.1959375 2.60390625 2.296875 3.9453125 C2.44701769 5.67195341 2.59810956 7.39851196 2.75 9.125 C2.811875 9.9809375 2.87375 10.836875 2.9375 11.71875 C3.43812874 17.14222803 4.31619236 20.74639477 8 25 C10.85007946 26.7196682 13.25094792 27.32103561 16.546875 27.6328125 C17.39121094 27.71660156 18.23554687 27.80039062 19.10546875 27.88671875 C20.41451172 28.00466797 20.41451172 28.00466797 21.75 28.125 C22.63816406 28.21136719 23.52632812 28.29773438 24.44140625 28.38671875 C26.62702936 28.59823066 28.81308238 28.80240227 31 29 C31 29.66 31 30.32 31 31 C29.69804688 31.09796875 28.39609375 31.1959375 27.0546875 31.296875 C25.32804659 31.44701769 23.60148804 31.59810956 21.875 31.75 C21.0190625 31.811875 20.163125 31.87375 19.28125 31.9375 C13.85777197 32.43812874 10.25360523 33.31619236 6 37 C4.2803318 39.85007946 3.67896439 42.25094792 3.3671875 45.546875 C3.28339844 46.39121094 3.19960938 47.23554687 3.11328125 48.10546875 C3.03464844 48.97816406 2.95601562 49.85085937 2.875 50.75 C2.78863281 51.63816406 2.70226562 52.52632812 2.61328125 53.44140625 C2.40176934 55.62702936 2.19759773 57.81308238 2 60 C1.34 60 0.68 60 0 60 C-0.09796875 58.69804688 -0.1959375 57.39609375 -0.296875 56.0546875 C-0.44701769 54.32804659 -0.59810956 52.60148804 -0.75 50.875 C-0.811875 50.0190625 -0.87375 49.163125 -0.9375 48.28125 C-1.43812874 42.85777197 -2.31619236 39.25360523 -6 35 C-8.85007946 33.2803318 -11.25094792 32.67896439 -14.546875 32.3671875 C-15.39121094 32.28339844 -16.23554688 32.19960938 -17.10546875 32.11328125 C-17.97816406 32.03464844 -18.85085937 31.95601562 -19.75 31.875 C-20.63816406 31.78863281 -21.52632812 31.70226562 -22.44140625 31.61328125 C-24.62702936 31.40176934 -26.81308238 31.19759773 -29 31 C-29 30.34 -29 29.68 -29 29 C-27.69804687 28.90203125 -26.39609375 28.8040625 -25.0546875 28.703125 C-23.32804659 28.55298231 -21.60148804 28.40189044 -19.875 28.25 C-19.0190625 28.188125 -18.163125 28.12625 -17.28125 28.0625 C-11.87061737 27.56305699 -8.21685787 26.71532235 -4 23 C-0.18312663 16.29267883 -0.34151581 7.51334788 0 0 Z"
                                    fill="white"
                                    transform="translate(31,2)" />
                            </svg>
                        </div>

                        <div className="counter-item">
                            <span className="counter-number">{String(timeLeft.hours).padStart(2, "0")}</span>
                            <span className="counter-label">HRS</span>
                        </div>

                        <div className="counter-divider">
                            <svg className="divider-sparkle" viewBox="0 0 64 64">
                                <path d="M0 0 C0.66 0 1.32 0 2 0 C2.09796875 1.30195312 2.1959375 2.60390625 2.296875 3.9453125 C2.44701769 5.67195341 2.59810956 7.39851196 2.75 9.125 C2.811875 9.9809375 2.87375 10.836875 2.9375 11.71875 C3.43812874 17.14222803 4.31619236 20.74639477 8 25 C10.85007946 26.7196682 13.25094792 27.32103561 16.546875 27.6328125 C17.39121094 27.71660156 18.23554687 27.80039062 19.10546875 27.88671875 C20.41451172 28.00466797 20.41451172 28.00466797 21.75 28.125 C22.63816406 28.21136719 23.52632812 28.29773438 24.44140625 28.38671875 C26.62702936 28.59823066 28.81308238 28.80240227 31 29 C31 29.66 31 30.32 31 31 C29.69804688 31.09796875 28.39609375 31.1959375 27.0546875 31.296875 C25.32804659 31.44701769 23.60148804 31.59810956 21.875 31.75 C21.0190625 31.811875 20.163125 31.87375 19.28125 31.9375 C13.85777197 32.43812874 10.25360523 33.31619236 6 37 C4.2803318 39.85007946 3.67896439 42.25094792 3.3671875 45.546875 C3.28339844 46.39121094 3.19960938 47.23554687 3.11328125 48.10546875 C3.03464844 48.97816406 2.95601562 49.85085937 2.875 50.75 C2.78863281 51.63816406 2.70226562 52.52632812 2.61328125 53.44140625 C2.40176934 55.62702936 2.19759773 57.81308238 2 60 C1.34 60 0.68 60 0 60 C-0.09796875 58.69804688 -0.1959375 57.39609375 -0.296875 56.0546875 C-0.44701769 54.32804659 -0.59810956 52.60148804 -0.75 50.875 C-0.811875 50.0190625 -0.87375 49.163125 -0.9375 48.28125 C-1.43812874 42.85777197 -2.31619236 39.25360523 -6 35 C-8.85007946 33.2803318 -11.25094792 32.67896439 -14.546875 32.3671875 C-15.39121094 32.28339844 -16.23554688 32.19960938 -17.10546875 32.11328125 C-17.97816406 32.03464844 -18.85085937 31.95601562 -19.75 31.875 C-20.63816406 31.78863281 -21.52632812 31.70226562 -22.44140625 31.61328125 C-24.62702936 31.40176934 -26.81308238 31.19759773 -29 31 C-29 30.34 -29 29.68 -29 29 C-27.69804687 28.90203125 -26.39609375 28.8040625 -25.0546875 28.703125 C-23.32804659 28.55298231 -21.60148804 28.40189044 -19.875 28.25 C-19.0190625 28.188125 -18.163125 28.12625 -17.28125 28.0625 C-11.87061737 27.56305699 -8.21685787 26.71532235 -4 23 C-0.18312663 16.29267883 -0.34151581 7.51334788 0 0 Z"
                                    fill="white"
                                    transform="translate(31,2)" />
                            </svg>
                        </div>

                        <div className="counter-item">
                            <span className="counter-number">{String(timeLeft.minutes).padStart(2, "0")}</span>
                            <span className="counter-label">MIN</span>
                        </div>

                        <div className="counter-divider">
                            <svg className="divider-sparkle" viewBox="0 0 64 64">
                                <path d="M0 0 C0.66 0 1.32 0 2 0 C2.09796875 1.30195312 2.1959375 2.60390625 2.296875 3.9453125 C2.44701769 5.67195341 2.59810956 7.39851196 2.75 9.125 C2.811875 9.9809375 2.87375 10.836875 2.9375 11.71875 C3.43812874 17.14222803 4.31619236 20.74639477 8 25 C10.85007946 26.7196682 13.25094792 27.32103561 16.546875 27.6328125 C17.39121094 27.71660156 18.23554687 27.80039062 19.10546875 27.88671875 C20.41451172 28.00466797 20.41451172 28.00466797 21.75 28.125 C22.63816406 28.21136719 23.52632812 28.29773438 24.44140625 28.38671875 C26.62702936 28.59823066 28.81308238 28.80240227 31 29 C31 29.66 31 30.32 31 31 C29.69804688 31.09796875 28.39609375 31.1959375 27.0546875 31.296875 C25.32804659 31.44701769 23.60148804 31.59810956 21.875 31.75 C21.0190625 31.811875 20.163125 31.87375 19.28125 31.9375 C13.85777197 32.43812874 10.25360523 33.31619236 6 37 C4.2803318 39.85007946 3.67896439 42.25094792 3.3671875 45.546875 C3.28339844 46.39121094 3.19960938 47.23554687 3.11328125 48.10546875 C3.03464844 48.97816406 2.95601562 49.85085937 2.875 50.75 C2.78863281 51.63816406 2.70226562 52.52632812 2.61328125 53.44140625 C2.40176934 55.62702936 2.19759773 57.81308238 2 60 C1.34 60 0.68 60 0 60 C-0.09796875 58.69804688 -0.1959375 57.39609375 -0.296875 56.0546875 C-0.44701769 54.32804659 -0.59810956 52.60148804 -0.75 50.875 C-0.811875 50.0190625 -0.87375 49.163125 -0.9375 48.28125 C-1.43812874 42.85777197 -2.31619236 39.25360523 -6 35 C-8.85007946 33.2803318 -11.25094792 32.67896439 -14.546875 32.3671875 C-15.39121094 32.28339844 -16.23554688 32.19960938 -17.10546875 32.11328125 C-17.97816406 32.03464844 -18.85085937 31.95601562 -19.75 31.875 C-20.63816406 31.78863281 -21.52632812 31.70226562 -22.44140625 31.61328125 C-24.62702936 31.40176934 -26.81308238 31.19759773 -29 31 C-29 30.34 -29 29.68 -29 29 C-27.69804687 28.90203125 -26.39609375 28.8040625 -25.0546875 28.703125 C-23.32804659 28.55298231 -21.60148804 28.40189044 -19.875 28.25 C-19.0190625 28.188125 -18.163125 28.12625 -17.28125 28.0625 C-11.87061737 27.56305699 -8.21685787 26.71532235 -4 23 C-0.18312663 16.29267883 -0.34151581 7.51334788 0 0 Z"
                                    fill="white"
                                    transform="translate(31,2)" />
                            </svg>
                        </div>

                        <div className="counter-item">
                            <span className="counter-number">{String(timeLeft.seconds).padStart(2, "0")}</span>
                            <span className="counter-label">SEC</span>
                        </div>

                    </div>

                    <div className="layout4C-subtitle" style={{ color: canvas?.subTitleTextColor }}>
                        {subTitle}
                    </div>

                </div>
            )}

        </div>
    )
}

export default Layout4C